import { render, staticRenderFns } from "./SubscriptionTerms.vue?vue&type=template&id=61105deb&scoped=true&"
var script = {}
import style0 from "./SubscriptionTerms.vue?vue&type=style&index=0&id=61105deb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61105deb",
  null
  
)

export default component.exports